export type AprRuntimeConfig = {
  apiBaseUrl?: string;
  portalUrl?: string;
  adminUrl?: string;
  aprName?: string;
  tenantId?: string;
  dteUrl?: string;
};

declare global {
  interface Window {
    __APR_CONFIG__?: AprRuntimeConfig;
  }
}

export function getAprName(): string {
  return window.__APR_CONFIG__?.aprName?.trim() || import.meta.env.VITE_APR_NAME?.trim() || "";
}

export function getApiBaseUrl(): string {
  return window.__APR_CONFIG__?.apiBaseUrl?.trim().replace(/\/$/, "") || "/api";
}

export function getTenantId(): string {
  return window.__APR_CONFIG__?.tenantId?.trim() || import.meta.env.VITE_ADMIN_TENANT_ID || "demo";
}

export function getDteUrl(): string {
  return window.__APR_CONFIG__?.dteUrl?.trim().replace(/\/$/, "") || "";
}
